import { FC, PropsWithChildren, createContext, useContext } from 'react';

import { useCreatePrePurchase } from './create-pre-purchase.hook';

type CreatePrePurchaseContext = ReturnType<typeof useCreatePrePurchase>;

const CreatePrePurchaseContext = createContext<CreatePrePurchaseContext | null>(
    null,
);

export const CreatePrePurchaseProvider: FC<PropsWithChildren> = ({
    children,
}) => {
    const value = useCreatePrePurchase();

    return (
        <CreatePrePurchaseContext.Provider value={value}>
            {children}
        </CreatePrePurchaseContext.Provider>
    );
};

export const useCreatePrePurchaseContext = () => {
    const context = useContext(CreatePrePurchaseContext);
    if (!context) {
        throw new Error(
            'useCreatePrePurchaseContext must be used within CreatePrePurchaseProvider',
        );
    }
    return context;
};
